import { getCookie, setCookies } from 'cookies-next';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import ReactDOMServer from "react-dom/server";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import Checkbox from '../Checkbox/Checkbox';
import styles from './AccessLoyalty.module.scss';



const AcceptLoyalty = ({ properties, setLoyalty, dataContent }) => {

    const {
        handleSubmit,
    } = useForm();

    const onSubmit = async (event) => {
        const res = await fetch(
            `${process.env.NEXT_PUBLIC_FE_LOYALTY_ADD}`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    access_token: JSON.parse(getCookie("myarea")).access_token,
                }),
            }
        );

        if (res) {
            const resjs = await res.json();
            if (resjs?.message) {
                setCookies(
                    "myarea",
                    {
                        access_token: JSON.parse(getCookie("myarea")).access_token,
                        refresh_token: JSON.parse(getCookie("myarea")).refresh_token,
                        loyalty: true,
                        first_name: JSON.parse(getCookie("myarea")).first_name,
                    },
                    {
                        maxAge: 3600,
                    }
                );
                Swal.fire({
                    title: properties[resjs.message],
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeButtonHtml: ReactDOMServer.renderToString(
                        <CloseIcon />
                    ),
                });

            }
            setLoyalty(true);

        }

    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.checkbox}>
                {/* commentato meccanismo di rimozione loyalty */}
                <Checkbox
                    name={
                        dataContent?.items[0]?.field?.name
                    }
                    text={
                        dataContent?.items[0]?.field?.values[0]
                    }
                    error={

                        dataContent?.items[0]?.field?.warning_field
                    }
                    inputProps={

                        `${dataContent?.items[0]?.field?.name}`

                    }
                    confirmButton={
                        dataContent?.button_title
                    }
                />
            </div>
        </form>
    )
}
export default AcceptLoyalty;